// extracted by mini-css-extract-plugin
export default {"SearchSorter":"SearchSorter_SearchSorter__IXwSC"};